$shm_hitalama_map_widget_float_tokens $shm_hitalama_map_widget_float
	controls /
		<= Tokens $mol_view
			sub /
				<= Tokens_label $mol_text
					text \Сбор осуществляется от имени
				<= Token_switch $shm_hitalama_vk_token_switch
					current => token
